import { c as _c } from "react/compiler-runtime";
import { T, Var } from "gt-next";
import { AuthProvider } from "@/types";
import * as SocialIcons from "@/components/presentational/tailwind/Auth/Icons";
function capitalize(word: string) {
  const lower = word.toLowerCase();
  return word.charAt(0).toUpperCase() + lower.slice(1);
}
export const RenderProviders = t0 => {
  const $ = _c(11);
  const {
    providers,
    onProviderLoginRequested,
    isLoading,
    isLogin: t1
  } = t0;
  const isLogin = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== isLoading || $[1] !== isLogin || $[2] !== onProviderLoginRequested || $[3] !== providers) {
    let t3;
    if ($[5] !== isLoading || $[6] !== isLogin || $[7] !== onProviderLoginRequested) {
      t3 = provider => {
        const AuthIcon = SocialIcons[provider];
        return <button className="shadow-xs focus:outline-hidden flex w-full cursor-pointer items-center justify-center gap-3 rounded-[16px] border border-gray-300 bg-white px-4 py-3.5 text-[15px] font-medium text-gray-800 transition-all duration-150 hover:border-gray-400 hover:bg-gray-50 focus:ring-2 focus:ring-gray-900 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" disabled={isLoading} onClick={() => onProviderLoginRequested(provider)} key={provider}><AuthIcon className="h-5 w-5" /><span>{isLogin ? <T>Log in with <Var name="provider">{capitalize(provider)}</Var></T> : <T>Sign up with <Var name="provider">{capitalize(provider)}</Var></T>}</span></button>;
      };
      $[5] = isLoading;
      $[6] = isLogin;
      $[7] = onProviderLoginRequested;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = providers.map(t3);
    $[0] = isLoading;
    $[1] = isLogin;
    $[2] = onProviderLoginRequested;
    $[3] = providers;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <div className="space-y-3">{t2}</div>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};